import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MechGradeAuth } from '../models/mech-grade-auth.model';

@Component({
  selector: 'app-mech-grade-override',
  templateUrl: './mech-grade-override.component.html',
  styleUrl: './mech-grade-override.component.scss'
})
export class MechGradeOverrideComponent {
  
  constructor(private modal: NgbActiveModal) { }

  isNoteEntry: boolean = false;
  mechanicMechGrade: string | undefined;
  noteText: string = '';
  @Input() buyerMechGrade: string | undefined;

  isMechGradeEnabled(grade: string): boolean {
    if (this.buyerMechGrade === 'GA') {
      return true;
    } else if (this.buyerMechGrade === 'GB') {
      return grade !== 'GA';
    } else {
      return grade === 'GC';
    }
  }

  dismissModal() {
    this.modal.dismiss();
  }

  setMechGradeAnswer(grade: string) {
    if (this.isMechGradeEnabled(grade)) {
      if (grade === this.buyerMechGrade) {
        this.modal.close(new MechGradeAuth(grade, null));
      } else {
        this.mechanicMechGrade = grade;
        this.isNoteEntry = true;
      }
    }
  }

  clear() {
    this.noteText = '';
  }

  approve() {
    this.modal.close(new MechGradeAuth(this.mechanicMechGrade, this.noteText));
  }
}
